// extracted by mini-css-extract-plugin
export default {"overlay":"ReportPopover_overlay__1ruB1","label":"ReportPopover_label__7I79V","textarea":"ReportPopover_textarea__uEMk4","actions":"ReportPopover_actions__Myt+K"};